import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { InfoArrendamiento } from 'src/app/models/info-arrendamiento';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { Home } from 'src/app/interfaces/home';
import { HomeResponse } from 'src/app/interfaces/home-response';
import { Locations } from 'src/app/models/locations';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { BodyEnvio2 } from 'src/app/interfaces/body-envio2';
import { environment } from 'src/environments/environment';
import { ResponseCotizador } from 'src/app/interfaces/response_cotizador';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { BodyNoPasaPoliticas } from 'src/app/interfaces/body_noPasaPoliticas';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { COTIZACION_PAUSA, LOADING_NO, TIEMPO_INACTIVO, ERROR, FEEDBACK } from 'src/app/routes.constants';

@Component({
  selector: 'app-info-arriendo-no',
  standalone: false,
  templateUrl: './info-arriendo-no.component.html',
  styleUrl: './info-arriendo-no.component.scss'
})
export class InfoArriendoNoComponent implements OnInit, OnDestroy {

  porcPantalla: string = '';
  msnPantalla: string = '';
  respon!: ResponseServices;
  private datosArrendamiento: InfoArrendamiento = {
    tipoPropiedad: '',
    ubicacion: '',
    valorAdministracion: 0,
    valorArriendo: 0,
    fechaContrato: '',
    duracionContrato: '',
    ServiciosPublicos: false,
    PaquetesAsistencia: false
  };

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }


  private noPasaPoliticas: BodyNoPasaPoliticas = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    screenPercentage: '',
    asesorCode: '',
    bitacoraId: '',
    leadRequeriment: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentType: '',
        DocumentNumber: ''
      },
      Property: {
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: ''
      }
    }
  }
  @ViewChild('ubicacion') tubicacion!: ElementRef;
  @ViewChild('valorArrendamiento') valorArrendamiento!: ElementRef;
  @ViewChild('valorAdmon') valorAdmon!: ElementRef;
  @ViewChild('rbtResidencial') rbtResidencial!: ElementRef;
  @ViewChild('rbtComercial') frbtComercial!: ElementRef;

 
  
  json: string = '';
  jsonFinal: string = '';
  valorArrTemp: number = 0;
  valorAdmonTemp: number = 0;
  tipoPropiedad: string = '';
  public parametro: string = '';
  bodyEnvio: Home = { getInitialData: false };
  homeRespose!: HomeResponse;
  locations: Locations[] = []
  states: string[] = [];
  swValidacionArriendo: boolean = false;
  swValidacionAdmon: boolean = false;
  swValidacionPorc: boolean = false;
  valNoAllowed = signal(false);

  dataEnvio: BodyEnvio2 = {
    SessionId: '',
    leadId: '',
    screenPercentage: '',
    productFamily: '',
    getScore: false,
    bitacoraId: '',
    asesorCode: '',
    leadRequirement: "Lead principal sin inquilino",
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Property: {
        AdministrationValue: 0,
        Department: '',
        RentalFee: 0,
        UseProperty: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  };

  response!: ResponseCotizador;
  ciudadSeleccionada: string = '';
  ciudadSeleccion: string = '';
  cantidad: string = '';

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  checador: any;
  saliendo: boolean = false;
  isMouseMove: any;
  leadId: string = '';
  sessionId: string = '';
  departamento: string[] = [];
  codAsesor: string = '';
  IdBitacora: string = '';


  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        this.parametro = JSON.stringify(this.datosGenerales);
        this.isActivity = false;
        this.saliendo = true;
        clearInterval(this.isMouseMove);
        clearTimeout(this.checador);
        this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '10', msnPll: 'Inactividad en llenar datos flujo sin inquilino', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  formulario: FormGroup = new FormGroup(
    {
      ubicacion: new FormControl('', [Validators.required]),
      valorArrendamiento: new FormControl('', [Validators.required, Validators.min(500000)]),
      valorAdmon: new FormControl('', [Validators.required, Validators.min(0)]),
      rbtResidencial: new FormControl(true),
      rbtComercial: new FormControl(false),
    }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  ngOnDestroy(): void {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.formulario.get("ubicacion")?.setValue(this.datosGenerales.InfoArrendamiento.ubicacion);
          this.formulario.get("valorArrendamiento")?.setValue(this.datosGenerales.InfoArrendamiento.valorArriendo);
          this.formulario.get("valorAdmon")?.setValue(this.datosGenerales.InfoArrendamiento.valorAdministracion);
          if (this.formulario.get("valorArrendamiento") !== null && this.formulario.get("valorAdmon") !== null) {
            this.valorArrTemp = this.datosGenerales.InfoArrendamiento.valorArriendo;
            this.valorAdmonTemp = this.datosGenerales.InfoArrendamiento.valorAdministracion;


          }

        }
      }

    });

    this.bodyEnvio.getInitialData = true;
    this.orquestadorService.postOrquestadorIntermedia(this.bodyEnvio).
      subscribe(
        (data) => {
          if (data !== undefined) {
            this.homeRespose = data;
            const vart = JSON.parse(JSON.stringify(this.homeRespose.data));
            this.locations = vart.locations

            this.locations.forEach(itemCiudad => {
              if (itemCiudad.SURACiudadDepartamento__c !== undefined) {
                this.states.push(itemCiudad.SURACiudadDepartamento__c)
              }
            });
          }
          this.seleccionarCiudad(this.datosGenerales.InfoArrendamiento.CityProperty!, this.datosGenerales.InfoArrendamiento.Department!);
        }
      )
  }

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.states.filter((v) =>
          v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  valUbicacion = false;
  valUbicacion2 = true;
  validacionUbicacion() {
    if (this.formulario.get("ubicacion")?.value === '') {
      this.valUbicacion = !this.valUbicacion;
      this.valUbicacion2 = !this.valUbicacion2;
    }
    else if (this.states.filter(ciu => ciu === this.formulario.get("ubicacion")?.value).length === 0) {
      this.valUbicacion = !this.valUbicacion;
      this.valUbicacion2 = !this.valUbicacion2;
    }
    else {
      this.seleccionarCiudad(this.formulario.get("ubicacion")?.value)

      this.ciudadSeleccionada = this.departamento[0];
      this.valUbicacion = false;
      this.valUbicacion2 = true;
    }
  }

  seleccionarCiudad(ubicacion: string, department?: string): void {
    this.locations.forEach(selecCiudad => {


      if ((selecCiudad.SURADepartamento__c === department && selecCiudad.SURACiudad__c === ubicacion) ||
        selecCiudad.SURACiudadDepartamento__c === ubicacion) {


        this.departamento = selecCiudad.SURADepartamento__c.split('-');

        this.datosArrendamiento.Department = selecCiudad.SURADepartamento__c; // meta
        this.datosArrendamiento.Code = selecCiudad.SURACodigo__c; //5050001
        this.datosArrendamiento.CityCode = selecCiudad.SuraCodigoCiudad__c; //50001
        this.datosArrendamiento.CityProperty = selecCiudad.SURACiudad__c; //Villavicencio
        this.datosArrendamiento.DepartmentCode = selecCiudad.SuraCodigoDepartamento__c; //50

        this.datosGenerales.Inmueble.ciudad = selecCiudad.SURACiudadDepartamento__c;

        this.formulario.get("ubicacion")?.setValue(selecCiudad.SURACiudadDepartamento__c);
        this.ciudadSeleccionada = this.departamento[0];
      }
    });
    this.datosGenerales.InfoArrendamiento = this.datosArrendamiento;
  }

  valValorArr = false;
  valValorArr2 = true;
  validacionValorArr() {
    this.valorArrTemp = 0;
    if (this.formulario.get("valorArrendamiento")?.value === '') {
      this.valValorArr = !this.valValorArr;
      this.valValorArr2 = !this.valValorArr2;
    } else if (this.formulario.get("valorArrendamiento")?.value < 500000) {
      this.swValidacionArriendo = true;
      this.valorArrendamiento.nativeElement.focus();
      return;
    }
    else {
      //this.formulario.get("valorArrendamiento")?.setValue(this.formulario.get("valorArrendamiento")?.value.replace('$', '').replace(',', '').replace('.', ''));
      this.valorArrTemp = Number(this.formulario.get("valorArrendamiento")?.value);
      this.swValidacionArriendo = false;
      this.datosArrendamiento.valorArriendo = this.valorArrTemp;
      this.datosGenerales.InfoArrendamiento = this.datosArrendamiento;

      // const formatter = new Intl.NumberFormat('en-US', {
      //   style: 'currency',
      //   currency: 'USD',
      //   minimumFractionDigits: 0
      // })

      //  this.formulario.get("valorArrendamiento")?.setValue(formatter.format(this.valorArrTemp).replace(',', '.').replace(',', '.'));
      this.valValorArr = false;
      this.valValorArr2 = true;
    }
  }

  valValorAdmon = false;
  valValorAdmon2 = true;
  validacionValorAdmon() {
    const porcetAdmon = this.valorArrTemp * 0.2;
    let letras = /[A-Za-z]/;
    this.valorAdmonTemp = Number(this.formulario.get("valorAdmon")?.value);

    if (letras.exec(this.formulario.get("valorAdmon")?.value)) {
      this.valValorAdmon = !this.valValorAdmon;
      this.valValorAdmon2 = !this.valValorAdmon2;
    }
    else if (this.valorAdmonTemp < 0) {
      this.swValidacionAdmon = true;
      this.formulario.get("valorAdmon")?.setValue('0');
      this.valorAdmonTemp = 0;
      return;
    }
    else if (this.valorAdmonTemp > porcetAdmon) {
      console.log('Valor administracion mayor');
      this.swValidacionPorc = true;
      this.valorAdmonTemp = 0;
      this.valNoAllowed.set(true);
      
      return;
    }
    else {
      console.log('Valor administracion admitido');

      // this.formulario.get("valorAdmon")?.setValue(this.formulario.get("valorAdmon")?.value.replace('$', '').replace(',', '').replace('.', ''));
      this.valorAdmonTemp = Number(this.formulario.get("valorAdmon")?.value);
      this.swValidacionAdmon = false;
      this.swValidacionPorc = false;  
      this.valNoAllowed.set(false);
      this.datosArrendamiento.valorAdministracion = this.valorAdmonTemp;
      this.datosGenerales.InfoArrendamiento = this.datosArrendamiento;

      // const formatter = new Intl.NumberFormat('en-US', {
      //   style: 'currency',
      //   currency: 'USD',
      //   minimumFractionDigits: 0
      // })

      //this.formulario.get("valorAdmon")?.setValue(formatter.format(this.valorAdmonTemp).replace(',', '.').replace(',', '.'));
      this.valValorAdmon = false;
      this.valValorAdmon2 = true;
    }
  }

  get valorArrNoValido() {
    return this.formulario.get("valorArrendamiento")?.invalid
      && this.formulario.get("valorArrendamiento")?.touched;
  }

  get valorAdmonNoValido() {
    if (this.formulario.get("valorAdmon")?.value === '') {
      this.formulario.get("valorAdmon")?.setValue('0');
      return true;
    }
    else {
      return this.formulario.get("valorAdmon")?.invalid
        && this.formulario.get("valorAdmon")?.touched
    }
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  radioChangeHandler(event: any) {
    this.tipoPropiedad = event.target.value;
  }

  nextPage() {
    if ((this.formulario.get('valorAdmon')?.value > 0 && this.formulario.get('valorArrendamiento')?.value > 0) && this.valorAdmonTemp === 0 && this.valorArrTemp === 0) {
      this.valorArrTemp = this.formulario.get('valorArrendamiento')?.value;
      this.valorAdmonTemp = this.formulario.get('valorAdmon')?.value;


    }
    this.datosArrendamiento.ubicacion = this.ciudadSeleccionada;
    this.datosArrendamiento.valorArriendo = this.valorArrTemp;
    this.datosArrendamiento.valorAdministracion = this.valorAdmonTemp;
    this.datosArrendamiento.tipoPropiedad = this.tipoPropiedad == '' ? 'Residencial' : this.tipoPropiedad;

    this.datosGenerales.InfoArrendamiento = this.datosArrendamiento;

    this.parametro = JSON.stringify(this.datosGenerales);

    const sumaValores = this.valorArrTemp + this.valorAdmonTemp;
    const porcetAdmon = this.valorArrTemp * 0.2;

    if (sumaValores > 5000000) {
      //this.router.navigate(['CotizacionPausa', { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '10', msnPll: 'Valor maximo de cannon + administración sin inquilino', infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
      this.porcPantalla = '10';
      this.msnPantalla = 'Valor maximo de cannon + administración sin inquilino';
      this.cotizacionEnPausa();
      this.router.navigate([FEEDBACK]);
    }
    else if (this.valorAdmonTemp > porcetAdmon) {
      this.router.navigate([COTIZACION_PAUSA, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '10', msnPll: 'el valor de la administracion no puede superar el 20% sin inquilino', infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
    }
    else if (this.tipoPropiedad === 'Comercial') {
      //this.router.navigate(['CotizacionPausa', { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '10', msnPll: 'Uso del inmueble sin inquilino', infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
      this.porcPantalla = '10';
      this.msnPantalla = 'Uso del inmueble sin inquilino'
      this.cotizacionEnPausa();
      this.router.navigate([FEEDBACK]);
    }
    else {
      this._dataLayerService.logArriendo("ecommerce_step_2", "Arrendamiento", "Datos Arrendamiento sin inquilino",
        this.sessionId, this.datosArrendamiento.valorArriendo.toString(), this.datosArrendamiento.valorAdministracion.toString(),
        this.datosArrendamiento.tipoPropiedad, this.departamento[0], this.datosArrendamiento.ubicacion
      );

      this.GuardarDataLayer();
    }
  }
  cotizacionEnPausa() {
    this.GuardaNoPasaPoliticas();
  }

  private GuardaNoPasaPoliticas() {
    this.noPasaPoliticas.SessionId = this.sessionId;
    this.noPasaPoliticas.productFamily = 'Arrendamiento';
    this.noPasaPoliticas.leadId = this.leadId;
    this.noPasaPoliticas.screenPercentage = this.porcPantalla;
    this.noPasaPoliticas.leadRequeriment = this.msnPantalla;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.noPasaPoliticas.asesorCode = this.codAsesor;
    }

    if (this.codAsesor !== undefined) {
      this.noPasaPoliticas.asesorCode = this.codAsesor;
    }
    else {
      this.codAsesor = '0';
    }

    this.noPasaPoliticas.bitacoraId = this.IdBitacora;
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.noPasaPoliticas.productsConfigurationData.Tenant.DocumentType = 'C';
    this.noPasaPoliticas.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.noPasaPoliticas.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.noPasaPoliticas.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.noPasaPoliticas.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.noPasaPoliticas.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;

    this.orquestadorService.postOrquestadorEnvioGen(this.noPasaPoliticas).
      subscribe(
        (data) => {
          this.respon = data;
        }
      );
  }

  private GuardarDataLayer() {

    this.dataEnvio.SessionId = this.sessionId;
    this.dataEnvio.productFamily = "Arrendamientos";
    this.dataEnvio.leadId = this.leadId;
    this.dataEnvio.screenPercentage = "10";
    this.dataEnvio.bitacoraId = this.IdBitacora;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor !== '') {
      this.dataEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    this.dataEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
    this.dataEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.dataEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.dataEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.dataEnvio.productsConfigurationData.Tenant.DocumentType = 'C';
    this.dataEnvio.productsConfigurationData.Property.AdministrationValue = this.valorAdmonTemp;
    this.dataEnvio.productsConfigurationData.Property.RentalFee = this.valorArrTemp;
    this.dataEnvio.productsConfigurationData.Property.Department = this.ciudadSeleccionada;
    this.dataEnvio.productsConfigurationData.Property.UseProperty = this.tipoPropiedad == '' ? 'Residencial' : this.tipoPropiedad;


    this.dataEnvio.productsConfigurationData.Property.DepartmentCode = this.datosArrendamiento.DepartmentCode;
    this.dataEnvio.productsConfigurationData.Property.CityProperty = this.datosArrendamiento.CityProperty;
    this.dataEnvio.productsConfigurationData.Property.Code = this.datosArrendamiento.Code;
    this.dataEnvio.productsConfigurationData.Property.CityCode = this.datosArrendamiento.CityCode;
    this.dataEnvio.productsConfigurationData.Property.DepartmentCode = this.datosArrendamiento.DepartmentCode;
    this.dataEnvio.productsConfigurationData.Property.CityProperty = this.datosArrendamiento.CityProperty;

    console.log('dataEnvio', JSON.stringify(this.dataEnvio));
    this.orquestadorService.postOrquestadorCotizador(this.dataEnvio).
      subscribe(
        (data) => {
          this.response = data;

          if (this.response.data.scoreAnalitico === 'Suscribe') {
            this.router.navigate([LOADING_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.scoreAnalitico === 'No suscribe (sin posibilidad, incluso con Codeudor)') {
            this.router.navigate([COTIZACION_PAUSA, { porcPll: '10', msnPll: 'No suscribe incluso con codeudor', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.scoreAnalitico === 'No suscribe (con posibilidad si hay Codeudor)') {
            this.router.navigate([COTIZACION_PAUSA, { porcPll: '10', msnPll: 'No suscribe con posibilidad si hay Codeudor', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.scoreAnalitico === 'No suscribe (NO SUCRIBE SIN POSIBILIDAD DE CODEUDOR)') {
            this.router.navigate([COTIZACION_PAUSA, { porcPll: '10', msnPll: 'No suscribe sin posibilidad de codeudor', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.scoreAnalitico === 'Falló el servicio') {
            this.router.navigate([ERROR, { porcPll: '10', msnPll: 'Falla en el servicio de Tarificación', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.scoreAnalitico === 'Tercero no existe en Transunion') {
            this.router.navigate([COTIZACION_PAUSA, { porcPll: '10', msnPll: 'Tercero no existe en Transunion', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

          if (this.response.data.quotesResponse === false) {
            this.router.navigate([LOADING_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          }

        },
        (error) => {
          this.router.navigate([ERROR, { porcPll: '10', msnPll: 'Falla en el servicio de Tarificación', codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
          return;
        }
      );
  }
}


